var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Frame_1017",
    "data-name": "Frame 1017",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Frame_1017_Background_Mask_",
    "data-name": "Frame 1017 (Background/Mask)",
    width: 48,
    height: 48,
    rx: 24,
    fill: "#e6e8ec"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons_File_Upload_Line",
    "data-name": "icons/File Upload/Line",
    transform: "translate(12 12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M14,22H4a4,4,0,0,1-4-4V4A4,4,0,0,1,4,0h8.344a4.024,4.024,0,0,1,2.828,1.172l1.657,1.657A4.024,4.024,0,0,1,18,5.657V18A4,4,0,0,1,14,22ZM4,2A2,2,0,0,0,2,4V18a2,2,0,0,0,2,2H14a2,2,0,0,0,2-2V7H14a3,3,0,0,1-3-3V2Zm9,.111V4a1,1,0,0,0,1,1h1.889a2.024,2.024,0,0,0-.475-.758L13.757,2.586A2.024,2.024,0,0,0,13,2.111Z",
    transform: "translate(3 1)",
    fill: "#777e90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M3.293.293l-3,3A1,1,0,0,0,1.707,4.707L3,3.414V8A1,1,0,1,0,5,8V3.414L6.293,4.707A1,1,0,0,0,7.707,3.293l-3-3a1,1,0,0,0-1.414,0Z",
    transform: "translate(8 9)",
    fill: "#777e90"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.a2208735935efdb671e6f1eabb4c31d3.svg";
export { ForwardRef as ReactComponent };